export class Servico {
    ativo: boolean;
    id: number;
    descricao: string;
    valor: number;
}

export class ServicoPlano {
    ativo: boolean;
    planoId: number;
    servicoId: number;
    periodicidadeOdometroHorimetro: number;
    alertaInicioOdometroHorimetro: number;
    periodicidadeTempo: number;
    referenciaTempo: number;
    alertaInicioTempo: number;
    id: number;
}

export class ServicoOrdemServico {
    ativo: boolean;
    id: number;
    data: string;
    descricao: string;
    quantidade: number;
    valor: number;
    ordemServicoId: number;
    servicoId: number;
    medidaId: number;
}

export class ServicoBem {
    ativo: boolean;
    bemId: number;
    planoId: number;
    servicoId: number;
    periodicidadeOdometroHorimetro: number;
    alertaInicioOdometroHorimetro: number;
    periodicidadeTempo: number;
    referenciaTempo: number;
    alertaInicioTempo: number;
    proximaExecucaoTempo: number;
    proximaExecucaoOdometroHorimetro: number;
    id: number;
}




/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/shared/servico.model.ts
 **/